import {
    Component,
    effect,
    EventEmitter,
    Input,
    Output,
    signal,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IShowHideExecutor } from '@lib-typing/person.interface';
import { NgClass, NgStyle } from '@angular/common';
import { Order } from '@libs-classes/order.class';
import { PersonStatusEnum } from '@libs-enums/status.enum';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PersonService } from '@lib-services/person.service';
import { MessageService } from '@lib-services/message.service';
import { TasksCountComponent } from '../../shared/tasks-count/tasks-count.component';
import { Person } from '@libs-classes/person.class';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ReplaceTasksComponent } from '../replace-tasks/replace-tasks.component';
import { filter } from 'rxjs';
import { TimeZoneService } from '@lib-services/time-zone.service';

@Component({
    selector: 'app-worker-card',
    standalone: true,
    imports: [
        MatIcon,
        NgClass,
        NgStyle,
        MatSlideToggle,
        TasksCountComponent,
        MatTooltip,
    ],
    templateUrl: './worker-card.component.html',
    styleUrl: './worker-card.component.scss'
})
export class WorkerCardComponent {
    @Input({required: true}) worker!: Person;
    @Input({required: true}) workerTasks!: Order[];
    @Input() showAllExecutorsSignal = signal<IShowHideExecutor>({
        time: new Date(),
        show: true,
    });
    @Input({required: true}) currentDate!:string;
    @Output() showHideExecutors: EventEmitter<IShowHideExecutor> = new EventEmitter();
    @Output() changedStatus = new EventEmitter();
    @Output() changedTasks = new EventEmitter();
    isVisible = true;
    time= new Date();
    total = 0;

    constructor(
        private personService: PersonService,
        private messageService: MessageService,
        private timeZoneService: TimeZoneService,
        private dialog: MatDialog,
    ) {
        effect(() => {
            const workerSettings = this.showAllExecutorsSignal();
            if (this.time !== workerSettings.time) {
                this.isVisible = workerSettings.show;
                this.showHideExecutors.emit({
                    id: this.worker.data.id,
                    show: this.isVisible
                });
            }
        });
    }

    getDate(): Date {
        const currentDay = this.currentDate.replace('$btw:', '').split(',')[0];
        const date = new Date(currentDay);
        date.setHours(date.getHours() + this.timeZoneService.currentTimeZone());
        return date;
    }

    showHide(): void {
        this.isVisible = !this.isVisible;
        this.showHideExecutors.emit({
            id: this.worker.data.id,
            show: this.isVisible
        });
    }

    get workTime(): {hours: number, minutes: number} {
        this.total = 0;

        for (const task of this.workerTasks) {
            if(task.data.dropDuration) {
                this.total += task.data.dropDuration;
                continue;
            }

            if (task.data.orderPrices && task.data.orderPrices.length) {
                let orderDuration = 0; // общее время заявки
                task.data.orderPrices?.forEach(order => {
                    if (order.price) {
                        orderDuration += order.price.duration * order.quantity;
                    }
                });
                orderDuration ? this.total += orderDuration : this.total += 20;
            } else {
                this.total += 20;
            }
        }
        return {
            hours: Math.trunc(this.total / 60),
            minutes: this.total % 60
        };
    }

    changeStatus(event: MatSlideToggleChange): void {
        if(this.workerTasks.length) {
            this.messageService.infoMessage('Нельзя сменить статус, пока у работника есть заявки');
            event.source.checked = this.isActive;
            return;
        }
        const status = !this.isActive ? PersonStatusEnum.active : PersonStatusEnum.inactive;
        this.personService.registerStatus(this.worker.data.id, this.getDate(), status).subscribe({
            next: () => {
                this.changedStatus.emit();
                this.messageService.successMessage('Статус работника изменен');
            },
            error: () => this.messageService.errorMessage('Статус работника не изменен')
        });
    }

    replaceTAsks(): void {
        this.dialog.open(ReplaceTasksComponent, {
            data: {
                worker: this.worker.data,
                workerTasks: this.workerTasks,
                currentDate: this.currentDate
            }
        }).afterClosed()
            .pipe(
                filter(data => data)
            ).subscribe({
                next: () => {
                    this.changedTasks.emit();
                }
            });
    }

    get isActive(): boolean {
        return this.worker.data.status === PersonStatusEnum.active;
    }

    // преобразование времени работника в соответствии с выбранной временной зоной
    // TODO если нужно будет преобразовывать время работника на шкале времени
    // workerWorkTime(time: string | null | undefined): string | null | undefined {
    //     return this.timeZoneService.setTimeZoneWorkTime(time);
    // }
}
